(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RunnerController', RunnerController);

    RunnerController.$inject = ['DataUtils', 'Runner'];

    function RunnerController(DataUtils, Runner) {

        var vm = this;

        vm.runners = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            Runner.query(function(result) {
                vm.runners = result;
                vm.searchQuery = null;
            });
        }
    }
})();
